import { AxiosRequestConfig } from 'axios';
import Customer from '../../models/Customer';
import API from '../API';

export const findCustomer = (
  queryParams: Record<string, unknown> = {},
  options: AxiosRequestConfig = {},
) => API.makeGetRequest(`/customer/find`, queryParams, options) as Promise<Customer[]>;

export const createNewCustomer = (
  body: Partial<Customer>,
  options: AxiosRequestConfig = {},
) => API.makePostRequest('/customer', body, options);

export const editCustomer = (
  body: Partial<Customer>,
  options: AxiosRequestConfig = {},
) => API.makePatchRequest('/customer', body,{}, options);
